import { GridCloseIcon } from "@mui/x-data-grid";
import Box from "components/common/Box";
import Drawer from "components/common/Drawer";
import IconButton from "components/common/IconButton";
import Text from "components/common/Text";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import Button from "components/common/Button";
import { MenuItem, Select } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "350px",
    padding: "16px" /* theme.spacing(2) is usually 8 * 2 = 16px */,
  },

  header: {
    display: "flex",
    justifyContent: " space-between",
    alignItems: "center",
    marginBottom: "16px" /* theme.spacing(2) */,
  },

  feedback: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px" /* theme.spacing(1) */,
    flexDirection: "column",
    gap: "8px" /* theme.spacing(1) */,
    backgroundColor:
      "#f5f5f5" /* theme.palette.background.default, adjust if different */,
    borderRadius: " 4px" /* theme.shape.borderRadius */,
  },
  lableyou: {
    fontSize: "13px",
  },

  reply: {
    padding: "8px" /* theme.spacing(1) */,
    // backgroundColor: 'white', /* theme.palette.background.paper */
    borderRadius: "4px" /* theme.shape.borderRadius */,
    border: "1px solid #e0e0e0" /* theme.palette.divider */,
    // backgroundColor: '#f5f5f5',
    width: "300px",
  },

  input: {
    display: "flex",
    position: "absolute",
    bottom: "20px",
    alignItems: "center",
    marginTop: "16px" /* theme.spacing(2) */,
    border: " 1px solid #e0e0e0" /* theme.palette.divider */,
    borderRadius: "4px" /* theme.shape.borderRadius */,
    flex: "1",
    marginLeft: "8px" /* theme.spacing(1) */,
  },

  sendButton: {
    padding: "3px 20px" /* theme.spacing(1) */,
  },
  dashedline: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "200px" /* Adjust the height as needed */,
    flexGrow: "1",
    width: "2px",
    borderRight: "2px dashed #ccc" /* Adjust the color as needed */,
    margin: "4px 0" /* Adjust the margin as needed */,
  },
  circle: {
    width: "20px" /* Adjust the size as needed */,
    height: "20px" /* Adjust the size as needed */,
    borderRadius: "50%",
    backgroundColor: "#ccc" /* Adjust the color as needed */,
  },

  fontSmall: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  text_container: {
    display: "flex",
    justifyContent: "space-between",
  },
  input_feild: {
    background: "rgba(0, 0, 0, 0.06)",
    border: "none",
    width: "200px",
    height: "40px",
    borderRadius: "10px",
  },
  save_button: {
    color: "green",
    marginTop: "5px",
  },
  approve_button_bx: {
    display: "flex",
    position: "absolute",
    bottom: "10px",
  },
  approve_button: {
    marginLeft: "30px",
  },
  save_edit_container: {
    display: "flex",
    justifyContent: "space-between",
  },
  save_button_bx: {
    color: "green",
    marginTop: "5px",
    cursor: "pointer",
    border:'none'
  },
  save_button_bx_disable: {
    marginTop: "5px",
    border:'none',
    cursor:'not-allowed'
  },

  show_save: {
    color: "green",
    marginTop: "5px",
    cursor: "pointer",
  },
  save_container: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const RequestDrawer = ({
  modelDropdownData,
  getVarientDropdown,
  getVarientDropdownData,
  drawerOpen,
  toggleDrawer,
  handleSubmit,
  response,
  dataid,
  handleApproveRequestVehicle,
  getModalDropdown,
  handleCloseModal,
  handleUpdateRequestVehicle,
  manufacturerInputFieldOpen,
  variantInputFieldOpen,modelInputFieldOpen
}) => {
  const [show, setShow] = useState(false);
 const [selected,setSelected] = useState({
  model:'',
  varient:'',
 })
 console.log("selected",selected);
 
  const toggleShowMore = () => {
    setShow(!show);
  };
 
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const date = new Date().toLocaleString();
useEffect(()=>{
  if(dataid?.manufacturer_id && drawerOpen)getModalDropdown(dataid?.manufacturer_id);
  setSelected((prevState) => ({
    ...prevState,
    ["model"]: dataid?.model_id,
    ["varient"]: dataid?.variant_id,
  }));
},[dataid?.manufacturer_id,drawerOpen])
useEffect(()=>{
 if(selected?.model && drawerOpen)getVarientDropdown(dataid?.manufacturer_id,selected?.model);
},[selected?.model,drawerOpen])
const handleChange = (event) => {
  const { name, value } = event.target;
  setSelected((prevState) => ({
    ...prevState,
    [name]: value,
  }));
};
const handleSaveClick = () => {
  handleUpdateRequestVehicle(selected.model,selected.varient);
}
  return (
    <Drawer anchor="right" open={drawerOpen} onClose={handleCloseModal}>
      {response === "vehicle" && (
        <Box className={classes.root} role="presentation">
          <Box className={classes.header}>
            <Text style={{ fontSize: "20px" }} variant="h6">
              Request From {dataid?.customer_name}
            </Text>
            <IconButton
              aria-label="close"
              onClick={() => toggleDrawer(false)}
              sx={{
                color: (theme) => theme.palette.grey[400],
              }}
            >
              <GridCloseIcon />
            </IconButton>
          </Box>

          <Box className={classes.feedback}>
            <Box className={classes.reply}>
              <Box>
                <Box>
                  <Text className={classes.fontSmall}>Manufacturer</Text>
                    <div className={classes.text_container}>
                      <Text style={{ fontSize: "15px" }}>
                        {" "}
                        {dataid?.manufacturer}
                      </Text>
                    </div>
                 
                </Box>
              </Box>
              <Box>
                <Box>
                  <Box sx={{marginTop:'0.5rem'}}>
                    <Text className={classes.fontSmall}>Model</Text>
                      <div className={classes.save_container}>
                         <Select
                      name="model" // Name matches the state key
                      value={selected.model || 'Select model'} // Default value or selected value
                      onChange={handleChange} // Handle change function
                      sx={{ width: '100%' }}
                      size="small"
                    >
                        <MenuItem value={'Select model'}>
                          Select model
                        </MenuItem>
                 { modelDropdownData?.map((val)=>(
                  <MenuItem value={val?.id}>
                          {val?.name}
                        </MenuItem>
                 ))
                        }
                
                    </Select>
                      </div>
                  </Box>
                </Box>
                <Box sx={{marginTop:'0.5rem'}}>
                  <Text className={classes.fontSmall}>Variant</Text>
                    <div className={classes.save_container}>
                         <Select
                      name="varient" // Name matches the state key
                      value={getVarientDropdownData?.some((item)=>item.id === selected.varient ) ? selected.varient : 'Select varient'} // Default value or selected value
                      onChange={handleChange} // Handle change function
                      sx={{ width: '100%' }}
                      size="small"
                    >
                        <MenuItem value={'Select varient'}>
                          Select varient
                        </MenuItem>
                        { getVarientDropdownData?.map((val)=>(
                  <MenuItem value={val?.id}>
                          {val?.name}
                        </MenuItem>
                 ))
                        }
                    </Select>
                    </div>
                </Box>
              </Box>
              <Box sx={{display:'flex',justifyContent:'flex-end'}}>
              <Button
              style={{marginTop:'1rem',fontSize:'0.8rem'}}
              variant="contained"
              onClick={handleSaveClick}
              disabled={modelInputFieldOpen|| variantInputFieldOpen|| manufacturerInputFieldOpen}
              >
                Save{" "}
              </Button>
                </Box>
            </Box>
            <Box className={classes.approve_button_bx}>
              <Button
                style={{ marginLeft: "30px" }}
                variant="contained"
                onClick={handleApproveRequestVehicle}
                disabled={modelInputFieldOpen|| variantInputFieldOpen|| manufacturerInputFieldOpen}
              >
                Approve{" "}
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                color="error"
                style={{ marginLeft: "70px" }}
                disabled={modelInputFieldOpen|| variantInputFieldOpen ||manufacturerInputFieldOpen}

              >
                Reject{" "}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
      {response === "connector" && (
        <Box className={classes.root} role="presentation">
          <Box className={classes.header}>
            <Text style={{ fontSize: "20px" }} variant="h6">
              Request From{dataid?.customer_name}
            </Text>
            <IconButton
              aria-label="close"
              onClick={() => toggleDrawer(false)}
              sx={{
                color: (theme) => theme.palette.grey[400],
              }}
            >
              <GridCloseIcon />
            </IconButton>
          </Box>

          <Box className={classes.feedback}>
            <Box className={classes.reply}>
              <Box>
                <Box>
                  <Text className={classes.fontSmall}>Connector</Text>
                  {!show ? (
                    <div className={classes.save_container}>
                      <Text style={{ fontSize: "15px" }}> Connector type</Text>
                      <EditIcon
                        onClick={toggleShowMore}
                        className={classes.fontSmall}
                      />
                    </div>
                  ) : (
                    <div className={classes.save_edit_container}>
                      <input
                        className={classes.input_feild}
                        type="edit"
                      ></input>

                      <span
                        className={classes.save_button}
                        onClick={toggleShowMore}
                      >
                        Save
                      </span>
                    </div>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.approve_button_bx}>
              <Button
                className={classes.approve_button}
                variant="contained"
                onClick={handleSubmit}
              >
                Approve{" "}
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                color="error"
                style={{ marginLeft: "70px" }}
              >
                Reject{" "}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Drawer>
  );
};

export default RequestDrawer;
